




















import { useChannelsStore } from "@/store/useChannelsStore";
import { defineComponent, PropType } from "@vue/composition-api";
import { UseTimeAgo } from "@vueuse/components";
import { BAlert, BAvatar, BBadge, BButton } from "bootstrap-vue";

export default defineComponent({
    components: {
        BAlert,
        BAvatar,
        BBadge,
        BButton,
        UseTimeAgo,
    },
    props: {
        customerCareWindow: {
            type: Object as PropType<{ hours: number; minutes: number }>,
            required: true,
        },
    },
    setup() {
        const { activeChatChannel } = useChannelsStore();

        return {
            activeChatChannel,
        };
    },
});
